export default __webpack_public_path__ + "static/media/quiz_adventure.ab924107.svg";